<template>
  <ion-img ref="imgRef" :src="imgSrc" @ionError="loadError" @ionImgDidLoad="loadComplete" />
</template>

<script setup lang="ts">
import { IonImg } from "@ionic/vue";

const props = defineProps({
  errorImage: String,
  lowResolutionImage: {
    type: String,
    required: true,
  },
  highResolutionImage: {
    type: String,
    required: true,
  },
})

const highResolutionImageLoaded = ref(false);

const imgSrc = computed(() => highResolutionImageLoaded.value ? props.highResolutionImage : props.lowResolutionImage);

const imgRef = ref<typeof IonImg | null>(null); // Add type annotation for imgRef

const loadComplete = () => {
  const img = new Image();
  img.src = props.highResolutionImage;
  img.onload = () => {
    highResolutionImageLoaded.value = true;
    if (imgRef.value) {
      imgRef.value.$el.classList.remove('error-img');
    }
  };
}

const loadError = (e: any) => {
  e.target.src = props.errorImage;
};

</script>